// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"HomeBanner_heroBanner__R0VNJ","mobile":"HomeBanner_mobile__W3Cja","desktop":"HomeBanner_desktop__IqBY4"};